/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseNotificationData } from './BaseNotificationData';
export type GameVersionRejectedNotification = (BaseNotificationData & {
    gameId: number;
    gameVersion: number;
    type: GameVersionRejectedNotification.type;
    detail: string;
});
export namespace GameVersionRejectedNotification {
    export enum type {
        GAME_REJECTED = 'game_rejected',
    }
}

